import NumericInput from '@/components/forms/components/numericInput';
import { WidgetWriterProps } from '../widget.type';

export const NumericInputWidget = ({
  id,
  placeholder = '',
  value = '',
  disabled = false,
  readOnly = false,
  autoFocus = false,
  onChange,
  onBlur,
  onFocus
}: WidgetWriterProps) => {
  const handleChange = value => {
    onChange(value !== null ? value : '');
  };

  return (
    <NumericInput
      id={id}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      readOnly={readOnly}
      autoFocus={autoFocus}
      onChange={handleChange}
      onBlur={e => onBlur(id, e.target.value)}
      onFocus={e => onFocus(id, e.target.value)}
    />
  );
};
